export default function EcpConfigurationFilter(EcpNavigationTab, EcpConfig) {
    var config = {}
    switch (EcpNavigationTab) {
        case "abstract":
            config = {tab: EcpNavigationTab, nb_elements: EcpConfig.nb_sentences_abstract, max_elements: EcpConfig.max_abstract, min_elements: EcpConfig.min_abstract}
            break
        case "summary":
            config = {tab: EcpNavigationTab, nb_elements: EcpConfig.nb_sentences_summary, max_elements: EcpConfig.max_summary, min_elements: EcpConfig.min_summary}
            break
        case "keypoints":
            config = {tab: EcpNavigationTab, nb_elements: EcpConfig.nb_keypoints, max_elements: EcpConfig.max_keypoints, min_elements: EcpConfig.min_keypoints}
            break
        case "verbatims":
            config = {tab: EcpNavigationTab, nb_elements: EcpConfig.nb_verbatims, max_elements: EcpConfig.max_verbatims, min_elements: EcpConfig.min_verbatims}
            break
        case "glossary":
            config = {tab: EcpNavigationTab, nb_elements: EcpConfig.nb_terms, max_elements: EcpConfig.max_terms, min_elements: EcpConfig.min_terms}
            break
        default:
            break
    }
    return config
}